import React from 'react';

function AnythingDetailsImageUrl({ anything, ...rest }) {
  const { value1: imageUrl, value2: altText } = anything;

  return (
    <div {...rest}>
      <img src={imageUrl} alt={altText} />
    </div>
  );
}

export default AnythingDetailsImageUrl;
